// src/components/Toast.js
import React from 'react';
import { createPortal } from 'react-dom';

const Toast = ({ type = 'success', children }) => {
  return createPortal(
    <div className={`login-${type}`}>
      {children}
    </div>,
    document.body
  );
};

export default Toast;
